module.exports = __webpack_public_path__ + "img/5D.434286e8.svg";